import React from 'react';
import {
  Columns,
  StyledFirstColumn,
  StyledFormContainer,
  StyledPaperContainer,
  StyledSecondColumn,
} from '../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import useMasterMedicineForm from '../hooks/useMasterMedicineForm';
import MasterMedicineNameEditor from './Editors/MasterMedicineNameEditor';
import { MasterMedicine as IMasterMedicine } from '../../../apis/master-medicines/types';
import { MasterMedicineFooter } from './MasterMedicineFooter';
import { ColumnWithGap } from '../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import MasterMedicineImageEditor from './Editors/MasterMedicineImageEditor';
import MasterMedicineDescriptionEditor from './Editors/MasterMedicineDescriptionEditor';
import { VirtualMedicine } from '../../../apis/virtual-medicines/types';
import VirtualMedicinesList from './VirtualMedicineList/VirtualMedicinesList';
import TextEditor from '../../FormEditors/TextEditor';
import ImageEditor from '../../FormEditors/ImageEditor';
import ColorEditor from '../../FormEditors/ColorEditor';
import HtmlEditor from '../../FormEditors/HtmlEditor';

interface MasterMedicineProps {
  masterMedicine?: IMasterMedicine | null;
  medicines?: VirtualMedicine[];
}

const MasterMedicine = ({ masterMedicine, medicines }: MasterMedicineProps) => {
  const form = useMasterMedicineForm(masterMedicine);

  return (
    <StyledFormContainer>
      <Columns>
        <StyledFirstColumn>
          <StyledPaperContainer>
            <ColumnWithGap>
              <MasterMedicineNameEditor form={form} />
              <MasterMedicineImageEditor form={form} />
              <MasterMedicineDescriptionEditor form={form} />
              <TextEditor label="Generic name" control={form.control} name="generic_name" />
              <TextEditor label="Category" control={form.control} name="category" />
              <TextEditor label="Strength range" control={form.control} name="strength_range" />
              <TextEditor label="Form" control={form.control} name="form" />
              <ImageEditor
                control={form.control}
                name="transparent_thumbnail_url"
                label="Transparent thumbnail"
                suggestedSize="512x512px"
                height="140px"
                width="140px"
              />
              <ImageEditor
                control={form.control}
                name="thumbnail_url"
                label="Thumbnail"
                suggestedSize="512x512px"
                height="140px"
                width="140px"
              />
              <ColorEditor
                control={form.control}
                name="card_color"
                label="Treatment card color (#hex)"
              />
              <HtmlEditor control={form.control} name="safety_information" label="Safety information" />
            </ColumnWithGap>
          </StyledPaperContainer>
          <MasterMedicineFooter id={masterMedicine?._id} form={form} />
        </StyledFirstColumn>
        {masterMedicine && (
          <StyledSecondColumn>
            <VirtualMedicinesList masterMedicine={masterMedicine} medicines={medicines || []} />
          </StyledSecondColumn>
        )}
      </Columns>
    </StyledFormContainer>
  );
};

export default MasterMedicine;
